import React from "react";
import { Link } from "react-router-dom";
import styles from "./Logo.module.scss";
import logo from "../../../../assets/img/logo.svg";

export const Logo: React.FC = () => {
  return (
    <div className={styles.logo}>
      <Link to="/">
        <img src={logo} alt="Company's logo" />
      </Link>
    </div>
  );
};

